import React from "react";
import PropTypes from "prop-types";
import { formatDateTime } from "helpers/formaters";
import { withStyles } from "@material-ui/styles";
import { Typography } from "@material-ui/core";

const styles = () => ({
    root: {
        whiteSpace: "nowrap"
    },
    notAvailable: {
      color: "rgba(0,0,0,0.4)",
      fontStyle: "italic"
    },
});

const Datetime = (props) => {
  const { value, onEmptyValueElement, component, classes, ...rest } = props;

  let Component = component || "span";
  if (!value)  {
    if (onEmptyValueElement) {
        return onEmptyValueElement;
    }
    else {
        if (onEmptyValueElement === undefined) {
            return <Typography variant="body1" className={classes.notAvailable}>N/A</Typography>;
        }
    }
  }
  return (
    <Component className={classes.root} {...rest}>{formatDateTime(value)}</Component>
  );
};

Datetime.propTypes = {
  component: PropTypes.string,
  value: PropTypes.any,
  ifNullValue: PropTypes.any,
};

export default withStyles( styles )(Datetime);
